export default {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }